import { Box, Typography } from '@mui/material';

interface DepositListItemProps {
  label: string;
  sublabel?: string;
  icon?: React.ReactNode;
  rightContent?: React.ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
}

export const DepositListItem = ({
  label,
  sublabel,
  icon,
  rightContent,
  isActive,
  isDisabled,
  onClick,
}: DepositListItemProps) => {
  return (
    <Box
      onClick={isDisabled ? undefined : onClick}
      className={`mb-1 flex items-center justify-between rounded-xl px-2 py-3 transition-all ${
        isDisabled
          ? 'cursor-not-allowed opacity-40'
          : `cursor-pointer hover:bg-[var(--hover-bg)] ${isActive ? 'bg-[var(--hover-bg)]' : ''}`
      }`}
    >
      <Box className="flex items-center gap-4">
        {icon && (
          <Box className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border border-[var(--border-color)] bg-white/5 shadow-sm">
            {icon}
          </Box>
        )}
        <Box className="flex flex-col">
          <Typography className="text-base font-bold leading-tight text-[var(--text-primary)]">
            {label}
          </Typography>
          {sublabel && (
            <Typography className="mt-0.5 text-sm font-medium text-[var(--text-muted)]">
              {sublabel}
            </Typography>
          )}
        </Box>
      </Box>
      {rightContent && <Box>{rightContent}</Box>}
    </Box>
  );
};
